import { ApiClient } from './ApiClient';

export type MessageApiType = {
  message: string;
  message_en: string;
  url: string;
  alert_level: number;
  popup_flg: boolean;
  not_operation_flg: boolean;
} | null;

export const MessageApi = async (): Promise<MessageApiType> => {
  try {
    const response = await ApiClient.get<MessageApiType>('message');
    const message = response.data;
    return message;
  } catch (err) {
    // pass
  }

  return null;
};
